import {
  ItManagementDeleteSoftwareSetupContractDocument,
  ItManagementDeleteSoftwareSetupContractMutation,
  ItManagementDeleteSoftwareSetupContractMutationVariables,
  ItManagementGetSoftwareSetupsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteSoftwareSetupContract = () => {
  const [deleteSoftwareSetupContract, { loading }] = useMutation(
    ItManagementDeleteSoftwareSetupContractDocument,
    {
      extractorFn: (data: ItManagementDeleteSoftwareSetupContractMutation) =>
        data.itManagementMutations.deleteContractItmanagementSoftwareSetup,
    }
  )

  return {
    deleteSoftwareSetupContract(
      variables: ItManagementDeleteSoftwareSetupContractMutationVariables
    ) {
      return deleteSoftwareSetupContract({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: ItManagementGetSoftwareSetupsDocument,
            variables: {
              ids: [variables.softwareSetupId],
            },
          },
        ],
      })
    },
    loading,
  }
}
